import axios from 'axios';
import type { VotingAction } from '@hotjar/feedback/domain/common/Responses/VotingAction';

// FIXME: Please fix this. You may refer to CFE-266 for more details.
// eslint-disable-next-line func-params-args/func-params
export function sendResponseFeedback(
  votingAction: VotingAction,
  siteId: number,
  feedbackId: number,
  responseId: number,
): Promise<void> {
  return axios.put(`/api/v1/sites/${siteId}/feedback/${feedbackId}/responses/${responseId}`, {
    voting_action: votingAction,
  });
}
